import { COMMON_TEXT } from '@/helpers/common-text';
import { QUERY_STRING_STORE,USER_ID_KEY } from '@/helpers/constants';
import { generateRandomString } from '@/helpers/utility';
import { cloneDeep } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchSignageComponents,
  fetchSignageComponentNotice,
} from './queryRequest';
import { Message } from 'primereact/message';
import SignageComponentNotice from './SignageComponentNotice';
import SignageComponentOverview from './SignageComponentOverview';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class SignageComponents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      signageComponentsList: [],
      notice: '',
      tabActiveIndex: 0,
    };
    this.toastRef = React.createRef();
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.setState({ tenant }, () => {
        this.getSignageComponentData();
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    if (isTenantChanged) {
      this.setState({ tenant: tenant }, () => {
        this.getSignageComponentData();
      });
    }
  }

  componentWillUnmount() {}

  getSignageComponentData = async () => {
    const { tenant } = this.state;
    this.setState({ isLoading: true });
    const userId = sessionStorage.getItem(USER_ID_KEY);
    let signageComponentsList = await fetchSignageComponents({
      tenantId: tenant,
      userId: userId,
    });
    const signageComponentNotice = await fetchSignageComponentNotice({
      tenantId: tenant,
    });
    signageComponentsList = signageComponentsList || [];
    signageComponentsList.forEach(item => {
      item.rowId = generateRandomString(10);
      item.initData = cloneDeep(item);
    });
    signageComponentsList.sort((a, b) => a.display_order - b.display_order);

    const notice =
      signageComponentNotice &&
      signageComponentNotice.length > 0 &&
      signageComponentNotice[0].notice
        ? signageComponentNotice[0].notice
        : '';

    this.setState({
      signageComponentsList,
      notice,
      isLoading: false,
    });
  };

  renderMessageError = () => {
    const { tenant } = this.state;
    if (!tenant) {
      return (
        <Message
          severity="error"
          text={COMMON_TEXT.TENANT_NOT_SELECTED_PLEASE_SELECT}
        />
      );
    }
  };

  updateOverview = ({ isUpdate }) => {
    if (isUpdate) {
      this.getSignageComponentData();
    }
  };

  render() {
    const { isLoading, signageComponentsList, notice, tabActiveIndex } =
      this.state;

    return (
      <div className="signage-components-container">
        <div className="config-content">
          {this.renderMessageError() || (
            <>
              <div className="signage-components-header">
                <div className="tab-menu">
                  <button
                    className={`tab-btn${tabActiveIndex === 0 ? ' selected' : ''}`}
                    onClick={() => this.setState({ tabActiveIndex: 0 })}
                    type="button"
                  >
                    {COMMON_TEXT.COMPONENT}
                  </button>
                  <button
                    className={`tab-btn${tabActiveIndex === 1 ? ' selected' : ''}`}
                    onClick={() => this.setState({ tabActiveIndex: 1 })}
                    type="button"
                  >
                    {COMMON_TEXT.TITLE_NOTICE}
                  </button>
                </div>
              </div>

              <div className="signage-components-content-wrapper">
                {tabActiveIndex === 0 && (
                  <div className="m-0">
                    <SignageComponentOverview
                      isLoading={isLoading}
                      notice={notice}
                      signageComponentsList={signageComponentsList}
                      updateNotice={this.updateOverview}
                    />
                  </div>
                )}
                {tabActiveIndex === 1 && (
                  <div className="m-0">
                    <SignageComponentNotice
                      notice={notice}
                      isLoading={isLoading}
                      updateNotice={this.updateOverview}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

SignageComponents.propTypes = {};
SignageComponents.whyDidYouRender = true;
export default SignageComponents;
